<div class="powered-by-givi" [style.color]="color">
    Powered by
    <a href="https://www.somosgivi.com/" target="_blank" rel="noopener" class="brand">
        <img [src]="logoSrc" alt="Givi" class="logo">
    </a><ng-container *ngIf="vendorName"> | {{ vendorName }}</ng-container>
</div>
